import { useIntl } from '@doxyme/locale';
import { BodyS } from '@doxyme/ui/typography';
import { useTheme } from '@doxyme/ui/theme';
import { VirtualBackgroundContainer } from '../virtualBackgroundContainer/virtualBackgroundContainer';
import {
  type VirtualBackground,
  type GroupVirtualBackground,
} from '../constants';
import Box from '@mui/material/Box';
import { useVirtualBackgroundsListStyles } from './virtualBackgroundsList.styles';

import type { JSX } from 'react';

type VirtualBackgroundsListProps = {
  backgroundList: GroupVirtualBackground[];
  onSelect: (background: VirtualBackground) => Promise<void>;
  selectedBackgroundIndex: number;
};

export const VirtualBackgroundsList = ({
  backgroundList,
  onSelect,
  selectedBackgroundIndex,
}: VirtualBackgroundsListProps): JSX.Element => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const styles = useVirtualBackgroundsListStyles();

  return (
    <Box css={styles.container}>
      {backgroundList.map((backgroundItem) => (
        <Box key={backgroundItem.key} css={styles.section}>
          <BodyS color={theme.text.generic.primary}>
            {formatMessage({
              id: `virtualBackground.category.${backgroundItem.key}`,
            })}
          </BodyS>
          <Box css={styles.backgroundItem}>
            {backgroundItem.backgrounds.map((background) => (
              <VirtualBackgroundContainer
                key={background.name}
                background={background}
                onSelect={onSelect}
                selected={background.index === selectedBackgroundIndex}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
